import React, { useEffect, useState } from 'react';
import { logoutCleanup } from '../auth';
import { getUserManager, mayHaveOktaSession, usesWidgetSignIn } from '../auth/oktaConfig';
import { useAuth } from '../auth/use-auth-compat';
import { signOutOfWidgetSession } from '../auth/widget-token';
import { WidgetSignedOut } from './WidgetSignedOut';

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const Logout = () => {
  const { authState } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  // In the Forms widget the sign-out ends here: this page tells the widget and stays.
  const [signedOutOfWidget, setSignedOutOfWidget] = useState(false);

  useEffect(() => {
    if (isLoggingOut) return;
    // Not on the templates pages: they sign in through Okta even inside the widget.
    const inWidget = usesWidgetSignIn();
    // In widget mode this page loads with no session (the boot dropped it). Sign out anyway, so the
    // widget stops sending tokens and any Okta session beside it ends.
    if (!inWidget && !authState.isAuthenticated) return;
    setIsLoggingOut(true);
    try {
      logoutCleanup();
    } catch {
      // Storage blocked: the sign-out below must still run.
    }
    const um = getUserManager();
    if (inWidget) {
      // Stay here: a signed-in page would ask the widget for a token. If Okta may also have a session
      // here, end it through Okta. If that fails, still show the signed-out message.
      void signOutOfWidgetSession(um)
        .then(mayHaveOktaSession)
        .then((oktaMaySignOut) => (oktaMaySignOut ? um.startLogout() : undefined))
        .catch(() => undefined)
        .then(() => setSignedOutOfWidget(true));
      return;
    }
    um.startLogout();
  }, [authState, isLoggingOut]);

  return signedOutOfWidget ? <WidgetSignedOut /> : <div>Logging out...</div>;
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default Logout;
